import * as msal from "@azure/msal-browser";

const currUrl = window.location.origin + '/sign-in';

export const MsalPca = new msal.PublicClientApplication({
    auth: {
        clientId: "cb2ead97-d3cf-41c6-a3cd-34dd615bddf9",
        authority: "https://login.microsoftonline.com/1edb3aab-47db-4374-b380-7f62c970ef91",
        redirectUri: currUrl,
        OIDCOptions: {
            defaultScopes: ['User.Read']
        }
    },
    cache: {
        cacheLocation: 'localStorage'
    },
});
